<fs-dialog>
  <div mat-dialog-title>
    Switch Workspace
  </div>
  <mat-dialog-content>
    <div>
      <fs-filter [config]="filterConfig"></fs-filter>
    </div>
    <div class="environment-items">
      @for (environment of environments; track environment) {
        <div
            class="environment-item"
            (click)="switch(environment)">
          <div class="fs-row.gap-sm">
            <fs-badge
              shape="circle"
              [size]="30"
              [image]="environment.avatar?.tiny">
            </fs-badge>
            <div class="fs-column">
              <span>
                {{ environment.name }}
              </span>
              <div class="fs-row.gap-xs">
                @for (project of environment.projects; track project) {
                  <fs-badge
                    [size]="25"
                    [image]="project.avatar?.tiny">
                  </fs-badge>
                }
                @if (environment.projects.length > projectLimit) {
                  <span>
                    +&nbsp;{{ environment.projects.length - projectLimit }}
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
        mat-button
        [mat-dialog-close]="null"
        type="button">
      Done
    </button>
  </mat-dialog-actions>
</fs-dialog>